import React from 'react'
import Profile from './profile'

const Education = () => {
  return (
    <>
        <Profile/>
        <div className="section">
            <div className="container cc-education">
            <div className="h4 text-center mb-4 title">Education</div>
            <div className="card">
                <div className="row">
                <div className="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body cc-education-header">
                    <p>2018 - 2021</p>
                    <div className="h5">Bachelor's Degree</div>
                    </div>
                </div>
                <div className="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body">
                    <div className="h5">Bachelor of Science in Informatics</div>
                    <p className="category">Sokoine University of Agriculture • Morogoro Tanzania</p>
                    <p>Certificate of a Bachelor of Science in Informatics with a <strong>3.9 GPA</strong></p>
                    </div>
                </div>
                </div>
            </div>
            <div className="card">
                <div className="row">
                <div className="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body cc-education-header">
                    <p>2016 - 2018</p>
                    <div className="h5">High School</div>
                    </div>
                </div>
                <div className="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body">
                    <div className="h5">Economics, Geography and Advanced Mathematics</div>
                    <p className="category">Lindi Secondary School - Lindi Tanzania</p>
                    <p>Advanced certificate of secondary education with Division II of point 11.</p>
                    </div>
                </div>
                </div>
            </div>

            <div className="card">
                <div className="row">
                <div className="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body cc-education-header">
                    <p>2012 - 2015</p>
                    <div className="h5">Secondary School</div>
                    </div>
                </div>
                <div className="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body">
                    <div className="h5">Major subject: Basic Mathematics, Physics, Biology, English
                    language, Literature in English, Civics, Swahili, Geography, and
                    History</div>
                    <p className="category">Michiga Secondary School - Mtwara Tanzania</p>
                    <p>Certificate of secondary education with Division II of point 20.</p>
                    </div>
                </div>
                </div>
            </div>

            </div>
        </div>
    </>
  )
}

export default Education
